import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';

import { RestService } from "src/app/service/RestService";
import { User } from 'src/app/model/user';
import { environment } from 'src/environments/environment';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { AdminServiceLocal } from './AdminServiceLocal';

@Injectable({ providedIn: 'root' })
export class AdminService extends RestService {
  adminServiceLocal : AdminServiceLocal = new AdminServiceLocal();

  public getRoles(): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.getRoles();
    }

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.admin.getRoles, headers, params);
  }

  public searchUsers(user: User, roleName: string): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.searchUsers(user, roleName);
    }
    
    let params = {
      "firstName": user.firstName,
      "lastName": user.lastName,
      "email": user.email,
      "guid": user.guid,
      "roleName": roleName
    };
    
    return this.restPost(environment.api.admin.searchUsers, params);
  }

  public getUserRoleDetails(userRole: UserRoleDetails): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.getUserRoleDetails(userRole);
    }

    let params = {
      "roleName": userRole.role.roleName,
      "email": userRole.user.email
    };

    return this.restPost(environment.api.admin.displayUser, params);
  }

  public updateUserRole(userRole: UserRoleDetails): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.updateUserRole(userRole);
    }

    let params = {
      "roleName": userRole.role.roleName,
      "email": userRole.user.email,
      "guid": userRole.user.guid,
      "operation": userRole.user.operation == null ? "1" : userRole.user.operation,
      "sendNotification": userRole.role.sendNotification == null ?"1" : userRole.role.sendNotification,
    };

    return this.restPost(environment.api.admin.updateRole, params);
  }


  public sendWelcomeEmail(userRole: UserRoleDetails): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.sendWelcomeEmail(userRole);
    }

    let params = {
      "roleName": userRole.role.roleName,
      "email": userRole.user.email,
      "guid": userRole.user.guid
    };

    return this.restPost(environment.api.admin.sendWelcomeEmail, params);
  }

  public resetWINAttempts(email: string): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.resetWINAttempts(email);
    }
    
    let params = {
      "email": email
    };

    return this.restPost(environment.api.admin.resetWINAttempts, params);
  }

  //operation: 0=Send new password email, 1=MPR
  //emailAccess: 0=true, 1=false
  public resetPassword(email: string, operation: number, emailAccess: number): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.resetPassword(email, operation, emailAccess);
    }
    
    let params = {
      "email": email,
      "operation": operation,
      "emailAccess": emailAccess
    };

    return this.restPost(environment.api.admin.resetPassword, params);
  }  

  public setEmailAccess(email: string, operation: number): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.setEmailAccess(email, operation);
    }
    
    let params = {
      "email": email,
      "operation": operation
    };

    return this.restPost(environment.api.admin.setEmailAccess, params);
  }  

  public sendVerificationEmail(email: string): Observable<any> {
    if (environment.env == "local") {
      return this.adminServiceLocal.sendVerificationEmail(email);
    }
    
    let params = {
      "email": email
    };

    return this.restPost(environment.api.admin.sendVerificationEmail, params);
  }  
}
